module.exports = __webpack_public_path__ + "static/media/web_large_banner.b3587812.jpg";